import React, { useState } from "react";
import { Alert, Button, Form, Table } from "react-bootstrap";
import api from "../../axiosConfig";

export default function ReceivedInvoices() {
  const [days, setDays] = useState("30");
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const failure = e => setError(e?.response?.data?.detail || e?.message || "Operația nu a reușit.");

  async function load() {
    setBusy(true); setError(""); setData(null); setPage(0);
    try {
      const response = await api.get("/efactura/primite", { params: { days: Number(days) } });
      setData(response.data);
    } catch (e) { failure(e); }
    finally { setBusy(false); }
  }
  async function download(id) {
    setBusy(true); setError("");
    try {
      const response = await api.get(`/efactura/primite/${id}/zip`, { responseType: "blob" });
      const url = URL.createObjectURL(response.data);
      const a = document.createElement("a");
      a.href = url; a.download = `efactura_primita_${id}.zip`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) {
      if (e?.response?.data instanceof Blob) {
        try {
          const body = JSON.parse(await e.response.data.text());
          setError(body.detail || "Descărcarea nu a reușit.");
        } catch { setError("Descărcarea nu a reușit. Reîncercați."); }
      } else { failure(e); }
    } finally { setBusy(false); }
  }
  const query = search.toLocaleLowerCase("ro").trim();
  const filtered = (data?.items || []).filter(row =>
    [row.supplier_cif, row.details, row.id, row.upload_id].join(" ").toLocaleLowerCase("ro").includes(query));
  const visible = filtered.slice(page * 25, (page + 1) * 25);
  return <section className="p-3" aria-label="Facturi primite">
    <h2>Facturi primite de la furnizori</h2>
    <p>Lista se citește din SPV pentru firma curentă, la cerere. Nu se înregistrează automat în Intrări sau în contabilitate.</p>
    <Form onSubmit={e => { e.preventDefault(); load(); }} className="d-flex gap-3 align-items-end flex-wrap mb-3">
      <Form.Group controlId="received-days">
        <Form.Label>Perioada din SPV</Form.Label>
        <Form.Select value={days} disabled={busy} onChange={e => { setDays(e.target.value); setData(null); setPage(0); }}>
          {[1, 7, 15, 30, 60].map(n => <option key={n} value={n}>Ultimele {n} zile</option>)}
        </Form.Select>
      </Form.Group>
      <Button type="submit" disabled={busy}>{busy ? "Se lucrează…" : "Preia din SPV"}</Button>
    </Form>
    <p className="text-muted">Perioada privește data primirii în SPV. Arhiva ZIP conține documentele ANAF; descărcați-o pentru păstrare. Această listă nu este o arhivă permanentă.</p>
    {error && <Alert variant="danger" role="alert">{error}</Alert>}
    {data && <>
      <p role="status">{data.total} facturi primite — CUI {data.cif}; ultimele {data.days} zile.</p>
      <Form.Group controlId="received-search" className="mb-3">
        <Form.Label>Caută după CUI furnizor, ID sau detalii ANAF</Form.Label>
        <Form.Control value={search} onChange={e => { setSearch(e.target.value); setPage(0); }} />
      </Form.Group>
      <Table striped bordered responsive>
        <thead><tr><th>Primită în SPV</th><th>CUI furnizor</th><th>Detalii ANAF</th><th>ID ANAF</th><th>Descărcare</th></tr></thead>
        <tbody>{visible.map(row => <tr key={row.id}>
          <td>{row.received_at ? new Date(row.received_at).toLocaleString("ro-RO") : "—"}</td>
          <td>{row.supplier_cif || "—"}</td><td>{row.details}</td><td>{row.id}</td>
          <td><Button size="sm" disabled={busy} onClick={() => download(row.id)}>Descarcă ZIP</Button></td>
        </tr>)}
        {!visible.length && <tr><td colSpan={5}>{data.total ? "Nicio factură nu corespunde căutării." : "Nu există facturi primite în perioada selectată."}</td></tr>}
        </tbody>
      </Table>
      <div className="d-flex gap-3 align-items-center">
        <Button disabled={page === 0 || busy} onClick={() => setPage(page - 1)}>Înapoi</Button>
        <span>Pagina {page + 1} / {Math.max(1, Math.ceil(filtered.length / 25))}</span>
        <Button disabled={(page + 1) * 25 >= filtered.length || busy} onClick={() => setPage(page + 1)}>Înainte</Button>
      </div>
    </>}
  </section>;
}